import { render, staticRenderFns } from "./StorageFiles.vue?vue&type=template&id=5f6c8330&scoped=true"
import script from "./StorageFiles.vue?vue&type=script&lang=js"
export * from "./StorageFiles.vue?vue&type=script&lang=js"
import style0 from "./StorageFiles.vue?vue&type=style&index=0&id=5f6c8330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6c8330",
  null
  
)

export default component.exports